module.exports = __webpack_public_path__ + "img/lmxy_icon_m.db1a9def.png";